<template>
  <div class="home-wrapper">
    <tophead
      v-on:tabclick="tabClick"
      :index="initTab"
    />
    <div class="menu">
      <menuright
        v-on:tabclick="menuClick"
        v-on:showcode="showCodeClick"
      />
    </div>
    <img
      v-show="showCode"
      class="code"
      src="../assets/xiazai.png"
      alt=""
    >
    <div v-show="tabIndex>1" id="us">
      <about :index="tabIndex" />
    </div>
    <div v-show="tabIndex<2">
      <div class="title">
        <span class="big">情感课堂 —— </span>
        <span>深入提高你的情商爱商，品味身份更上一层楼</span>
      </div>
      <div>
        <course v-on:showbigcode="showBigCodeClick(true)"/>
      </div>
      <div
        id="appdes"
        class="title"
      >
        <span class="big">APP简介 —— </span>
        <span>超百万恋爱聊天回复，一键搜索复制高情商回复女生，让聊天变的简单</span>
      </div>
      <img
        style="width:100%;"
        src="../assets/appdes.png"
        alt=""
      >
    </div>
    <foot />
    <div
      class="masker"
      v-show="showBigCode"
      @click="showBigCodeClick(false)"
    >
      <img
        class="big-code"
        src="../assets/bigcode.png"
        alt=""
      >
    </div>
  </div>
</template>

<script>
import tophead from './head.vue'
import about from './about.vue'
import foot from './foot.vue'
import course from './course.vue'
import menuright from './menu.vue'
export default {
  name: 'home',
  data () {
    return {
      tabIndex: 0,
      initTab: 0,
      showCode: false,
      showBigCode: false
    };
  },
  props: {
    msg: String
  },
  components: {
    tophead,
    about,
    foot,
    course,
    menuright
  },
  methods: {
    tabClick (index) {
      console.log(index)
      this.tabIndex = index
      if (index == 1) {
        setTimeout(() => {
          document.querySelector('#appdes').scrollIntoView(true)
        }, 500);

      } else if(index==2||index==3){
        this.toUs()
      }
    },
    menuClick (index) {
      if (index === 0) {
        // 公司简介
        this.initTab = 2
        this.tabIndex = 2
        this.toUs()
      }
      if (index === 1) {
        // 关于我们
        this.initTab = 3
        this.tabIndex = 3
        this.toUs()
      }
      if (index === 3) {
        // 回到顶部
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }

    },
    showCodeClick (show) {
      this.showCode = show
    },
    showBigCodeClick (show) {
      this.showBigCode = show
    },
    toUs(){
      setTimeout(() => {
          document.querySelector('#us').scrollIntoView(true)
        }, 500);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-wrapper {
  min-width: 1216px;
  position: relative;
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  clear: both;
  height: 0px;
  font-size: 0px;
  visibility: hidden;
  display: block;
  content: " ";
}

.title {
  width: 100%;
  box-sizing: border-box;
  padding: 50px 30px 20px 30px;
  color: #dc371b;
  border-bottom: solid 4px #dc371b;
  font-size: 18px;
}

.title span {
  line-height: 42px;
}

.title .big {
  font-size: 30px;
}

.menu {
  position: fixed;
  z-index: 1024;
  top: 100px;
  right: 0;
}

.code {
  width: 150px;
  height: 150px;
  position: fixed;
  right: 80px;
  top: 230px;
}

.masker {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  text-align: center;
  z-index: 2000;
}

.masker .big-code {
  width: 400px;
  height: 400px;
  margin-top: 700px;
}
</style>
